import {Updatable} from '@gongxigames/framework/core/fragments/update/Updatable';

export class Timer extends Updatable {
    protected _currentTime = 0;
    protected _callback: Function;
    protected _duration: number;

    constructor(callback: Function, duration: number, start?: boolean) {
        super(start);

        this._callback = callback;
        this._duration = duration;
    }

    public start(): Timer {
        super.start();

        this._currentTime = 0;

        return this;
    }

    public update(dt: number): void {
        this._currentTime += dt;

        if (this._currentTime >= this._duration) {
            this._callback();

            this.stop();
        }
    }
}
